"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEBT_MANAGEMENT_PLAN = exports.CREDITOR_HARASSMENT = exports.BANKRUPTCY = void 0;
var BANKRUPTCY = 'bankruptcy';
exports.BANKRUPTCY = BANKRUPTCY;
var CREDITOR_HARASSMENT = 'creditorHarassment';
exports.CREDITOR_HARASSMENT = CREDITOR_HARASSMENT;
var DEBT_MANAGEMENT_PLAN = 'debtManagementPlan';
exports.DEBT_MANAGEMENT_PLAN = DEBT_MANAGEMENT_PLAN;